import React, { useState } from 'react';
import { GlobalStyles } from './styles/GlobalStyles';
import { Footer } from './components/Footer';
import { Documentation } from './pages/Documentation';
import { Explore2 } from './pages/Explore2';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  if (currentPage === 'documentation') {
    return (
      <>
        <GlobalStyles />
        <div className="App">
          <Documentation onBack={() => handlePageChange('home')} />
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <GlobalStyles />
      <div className="App">
        <Explore2 />
        <Footer />
      </div>
    </>
  );
}

export default App;
